import { useEffect } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import { useRouter } from 'next/router';
import { times } from 'lodash';

import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/ecocredits-day/pc/');
const US_NUM = 2;
const OTHER_NUM = 3;
const listNum = { us: US_NUM, ca: US_NUM };

export default function EarnMore() {
    const { t } = useLang('ecocreditsday.pageTabs.tabB');
    const { locale } = useRouter();
    const earnMoreListBottom = times(listNum[locale as keyof typeof listNum] || OTHER_NUM, (index) => `earnMore.card${index + 3}_desc`);
    const bgImgMap = { jp: ['earn_more_jp.webp', 'earn_more_jp.png'] };
    const bgImg = bgImgMap[locale as keyof typeof bgImgMap] || bgImgMap.jp;

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.earn-more', //触发元素
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            offset: 200, //从开始点滚动多少px触发,可为负数
            duration: 800, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timeline = new TimelineMax();
        const tweenA1 = TweenMax.to('.earn-more .title', 0.5, { opacity: 1 });
        const tweenA2 = TweenMax.to('.earn-more .left-card', 0.5, { opacity: 1, rotateX: 0 });
        const tweenA3 = TweenMax.to('.earn-more .right-card', 0.5, { opacity: 1 });
        const tweenB1 = TweenMax.to('.earn-more .common-card0', 0.5, { opacity: 1 });
        const tweenB2 = TweenMax.to('.earn-more .common-card1', 0.5, { opacity: 1 });
        const tweenB3 = TweenMax.to('.earn-more .common-card2', 0.5, { opacity: 1 });
        timeline.add(tweenA1).add(tweenA2).add(tweenA3, 0.7).add(tweenB1).add(tweenB2, 1.2).add(tweenB3, 1.3);
        sceneA1.setTween(timeline);
        controllerDay.addScene(sceneA1);
        return () => {
            sceneA1 && sceneA1.destroy();
        };
    }, []);

    return (
        <div className={`${styles.earnMore} earn-more`}>
            <div className="title">{t('earnMore.title')}</div>
            <div className="top-box-out">
                <div className="top-box">
                    <div className="left-card">
                        <div className="bg-img">
                            <EFPic name={bgImg} />
                        </div>
                        <div className="left-svg"></div>
                        <div className="left-desc">
                            {t.rich('earnMore.card1_desc', {
                                highLightNum: (text: string) => <span className={['jp'].includes(locale as string) ? '' : 'red-text'}>{text}</span>,
                            })}
                        </div>
                    </div>
                    <div className="common-card right-card">
                        <div className="common-svg right-svg"></div>
                        <div className="common-text">
                            {t.rich('earnMore.card2_desc', { highLightNum: (text: string) => <span className="red-text">{text}</span> })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom-box">
                {earnMoreListBottom.map((item: string, i) => (
                    <div className={`common-card common-card${i}`} key={item}>
                        <div className="common-svg"></div>
                        <div className="common-text">{t.rich(item, { highLightNum: (text: string) => <span className="red-text">{text}</span> })}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
